module.exports = __webpack_public_path__ + "static/media/1009199.87380862.png";